import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/level1.png'
import _imports_1 from '@/assets/images/level2.png'
import _imports_2 from '@/assets/images/level3.png'
import _imports_3 from '@/assets/images/level4.png'
import _imports_4 from '@/assets/images/level5.png'
import _imports_5 from '@/assets/images/level6.png'


const _withScopeId = n => (_pushScopeId("data-v-77e4dc89"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_7 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_8 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"width":"120px","margin":"0 auto","text-align":"center","font-weight":"bold"}
}
const _hoisted_11 = { class: "price" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_13 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多会员时长 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "折叠会员时长 ", -1))
const _hoisted_17 = { class: "desc-title" }
const _hoisted_18 = { class: "desc-contents" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能量体定制与版型下载", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打造企业自主品牌效应", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "助力企业管理效率的提升", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能量体定制与版型下载", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打造集团自主品牌效应", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "助力企业数字化转型", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实现订单生产和全流程数字化", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "对接智能量体定制系统", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能版型使用有效期与会员时间同步", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能版型下载数量", -1))
const _hoisted_29 = {
  key: 0,
  class: "free-count"
}
const _hoisted_30 = {
  key: 1,
  class: "free-count"
}
const _hoisted_31 = { style: {"display":"flex","justify-content":"center","position":"absolute","bottom":"10px"} }
const _hoisted_32 = {
  key: 0,
  style: {"width":"200px","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectedClick && _ctx.selectedClick(...args))),
    class: _normalizeClass(['lv-main',_ctx.props.level.showAll?'showAll':'',_ctx.props.level.selected?'selected':''])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.props.level.id==1)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_ctx.props.level.id==2)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_ctx.props.level.id==3)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (_ctx.props.level.id==4)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_ctx.props.level.id==5)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_ctx.props.level.id==6)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true),
      _createElementVNode("div", null, _toDisplayString(_ctx.props.level.levelName), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.level.subRows, (tern, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([[_ctx.selectedIndex==index?'tern-selected':'',!_ctx.props.level.showAll && index!=0?'hidden-item':''], "tern"]),
        key: tern.id,
        onClick: ($event: any) => (_ctx.ternClick(tern,index))
      }, [
        (_ctx.props.level.id==6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "咨询了解/量身定制"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", null, _toDisplayString(tern.tern==0?'终身':tern.tern+'个月'), 1),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(tern.amount), 1)
              ]),
              (_ctx.props.level.id!=4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(tern.tern==0?'--':(tern.amount/tern.tern).toFixed(0)) + "元/月", 1))
                : _createCommentVNode("", true)
            ], 64))
      ], 10, _hoisted_9))
    }), 128)),
    (!_ctx.props.level.showAll)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ()=>{_ctx.props.level.showAll=!_ctx.props.level.showAll}),
          class: "more"
        }, [
          _hoisted_15,
          _createVNode(_component_svg_icon, { icon: "down" })
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ()=>{_ctx.props.level.showAll=!_ctx.props.level.showAll}),
          class: "more"
        }, [
          _hoisted_16,
          _createVNode(_component_svg_icon, { icon: "up" })
        ])),
    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.props.level.levelName) + "权益 ", 1),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.props.level.id==5)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              _hoisted_19,
              _createVNode(_component_svg_icon, { icon: "success" })
            ]),
            _createElementVNode("div", null, [
              _hoisted_20,
              _createVNode(_component_svg_icon, { icon: "success" })
            ]),
            _createElementVNode("div", null, [
              _hoisted_21,
              _createVNode(_component_svg_icon, { icon: "success" })
            ])
          ], 64))
        : (_ctx.props.level.id==6)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", null, [
                _hoisted_22,
                _createVNode(_component_svg_icon, { icon: "success" })
              ]),
              _createElementVNode("div", null, [
                _hoisted_23,
                _createVNode(_component_svg_icon, { icon: "success" })
              ]),
              _createElementVNode("div", null, [
                _hoisted_24,
                _createVNode(_component_svg_icon, { icon: "success" })
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _createVNode(_component_svg_icon, { icon: "success" })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", null, [
                _hoisted_26,
                _createVNode(_component_svg_icon, { icon: "success" })
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _createVNode(_component_svg_icon, { icon: "success" })
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                (_ctx.props.level.id==4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "不限"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.props.level.count) + "个", 1))
              ])
            ], 64))
    ]),
    _createElementVNode("div", _hoisted_31, [
      (_ctx.props.level.id==6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 详情咨询:18628979063 "))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            onClick: _ctx.upgrade,
            type: "primary",
            style: {"margin-left":"60px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.orgId===1000?'购买会员':'入驻加盟'), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
    ])
  ], 2))
}